"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const screenConstants_1 = require("../../constants/screenConstants");
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const loanApplicationSlice_1 = require("./loanApplicationSlice");
const constants_1 = require("../../constants/constants");
const store_1 = require("../../store");
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const input_1 = __importStar(require("../../components/input/input"));
const choices_1 = require("../../utils/choices");
const NewLoanApplicationScreen = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const [loanLength, setLoanLength] = (0, react_1.useState)('');
    const [reason, setLoanReason] = (0, react_1.useState)('');
    const [amount, setLoanAmount] = (0, react_1.useState)(constants_1.MINIMUM_LOAN_VALUE);
    const [repaymentPeriodicity, setPeriodicity] = (0, react_1.useState)('');
    const [provideCheque, setProvideCheque] = (0, react_1.useState)('');
    const submitForm = async () => {
        const payload = {
            use_of_proceeds: reason,
            request_amount: amount,
            request_tenor_days: loanLength,
            request_repayment_periodicity: repaymentPeriodicity,
            can_provide_cheque: provideCheque,
        };
        dispatch((0, loanApplicationSlice_1.setLoanApplicationTerms)(payload));
        navigation.reset({ index: 0, routes: [{ name: screenConstants_1.HOME_SCREEN }, { name: screenConstants_1.LOAN_APPLICATION_SUMMARY_SCREEN }] });
    };
    return (react_1.default.createElement(navContainer_1.default, { isLoading: false, childrenTitle: "Loan Request", footer: react_1.default.createElement(primaryButton_1.default, { disabled: loanLength === '' || reason === '' || repaymentPeriodicity === '' || provideCheque === '', title: "Continue", onPress: submitForm, eventName: "apply_for_a_loan" }) },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_SLIDER, minimumValue: constants_1.MINIMUM_LOAN_VALUE, maximumValue: constants_1.MAXIMUM_LOAN_VALUE, value: amount, setValue: setLoanAmount, symbol: constants_1.NAIRA_SYMBOL, step: constants_1.LOAN_AMOUNT_STEP, error: null, label: "How much do you need?" }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: choices_1.loanReasonChoices, label: "Why do you need the loan?", setValue: setLoanReason, value: reason || '', error: null, required: true }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "How long do you need it for?", choices: choices_1.lengthChoices, setValue: setLoanLength, value: loanLength || '', error: null, required: true }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "How often would you like to repay?", choices: choices_1.periodicityChoices, setValue: setPeriodicity, value: repaymentPeriodicity || '', error: null, required: true }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Can you issue a cheque to secure your loan?", choices: choices_1.yesNoChoices, setValue: setProvideCheque, value: provideCheque, error: null, required: true })));
};
exports.default = NewLoanApplicationScreen;
